
import { NotificationConfiguration } from '../notification.templates';

export const MEETING_REQUEST_DOCUMENTS_TEMPLATE: NotificationConfiguration = {
  inapp: `Documents for agenda item are requested`,
  email: {
    ctaKey: 'upload_documents',
  },
};
